import type { InsertDepartmentTypeWithGroupNameMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

const mapTrpcResponseToGraphQL = (
  id: string
): InsertDepartmentTypeWithGroupNameMutation => {
  return {
    insert_department_type_one: {
      __typename: 'department_type',
      DepartmentTypeId: id,
    },
  };
};

export const useInsertDepartmentTypeWithGroupNameTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.department.insertTypeWithGroupName.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.department.allTypes.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.department.departmentTypeGroups.queryKey(),
        });
      },
    }),
  });

  return {
    insertDepartmentTypeWithGroupName: async (variables: {
      Name: string;
      Description?: string | null;
      DepartmentGroupName?: string | null;
    }): Promise<InsertDepartmentTypeWithGroupNameMutation> => {
      const result = await mutation.mutateAsync({
        Name: variables.Name,
        Description: variables.Description,
        DepartmentGroupName: variables.DepartmentGroupName,
      });

      return mapTrpcResponseToGraphQL(result.Id);
    },
    loading: mutation.isPending,
    error: mutation.error,
    data: mutation.data
      ? mapTrpcResponseToGraphQL(mutation.data.Id)
      : undefined,
  };
};
